<section
  class="toggle-form"
  [ngClass]="{ active: iseQMSScopeSliderOpen }"
>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"> </p-confirmDialog>
  <div class="formwrap">
    <div class="Header">
      <h1>
        <b>{{eQMSScopeSliderTitle}}</b>
      </h1>
      <p-button
      appPreventDoubleClick
        styleClass="p-button-text"
        id="eQMSScopeSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSlider()"
      ></p-button>
    </div>
    <div class="general-container">
    <form [formGroup]="eqmsScopeForm" (ngSubmit)="submitScopeForm()">
    <div class="form-container">
      <!-- Name Field -->
      <div class="field" *ngIf="isGlobalInstance">
        <bpt-text-input
          label="Name"
           [required]="true"
           [ngClass]="{ 'error-highlight': isFieldInvalid('name') }"
             [disabled]="false"
            id="name"
               formControlName="name"
            [maxlength]="255"
           ></bpt-text-input>
      </div>
       <div class="flex card-container" *ngIf="!isEditMode">
      <div class="label-wrapper">
      <label>Parent eQMS Scope <span class="required-asterisk">*</span></label>
    </div>
    <div class="flex flex-row scope-wrapper">
      <div class="tree-wrapper">
        <p-treeSelect
          selectionMode="single"
          [options]="parentTreeData"
          (onNodeSelect)="onParentScopeSelect($event)"
          [filter]="true"
          id="parentEqmsScope"
        ></p-treeSelect>
      </div>
      </div></div>

      <!-- Category Dropdown -->
      <div class="field" *ngIf="(isGlobalEqmsInstance && !isScopeManagerOnly) || !isEditMode">
        <bpt-dropdown 
          label="Category"
          [options]="scopeCategoryOptions"
          [editable]="false"
          formControlName="scopeCategory"
          id="scopeCategory"
          [required]="true"
          [showClear]="false"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField">
        </bpt-dropdown>
      </div>

      <!-- Source ITAAG Dropdown -->
      <div class="field" *ngIf="!(isScopeManagerOnly && isGlobalEqmsInstance) || (!isEditMode && !isScopeManagerOnly)">
        <bpt-dropdown 
          label="Source ITAAG"
          [options]="sourceItaagOptions"
          [editable]="false"
          formControlName="sourceItaag"
          id="sourceItaag"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          pTooltip = "This must only be populated for eQMS Scopes that are used as source eQMS Scopes for Global Document distribution.">
        </bpt-dropdown>
      </div>

      <!-- Checkboxes -->
      <div class="field checkbox-field" *ngIf="(isGlobalInstance && !isScopeManagerOnly) || !isEditMode">
        <p-checkbox
          [binary]="true"
          formControlName="acceptDocuments"
          label="Accept Documents"
        ></p-checkbox>
      </div>

      <div class="field checkbox-field" *ngIf="(isGlobalInstance && !isScopeManagerOnly) || !isEditMode">
        <p-checkbox
          [binary]="true"
          formControlName="acceptCourses"
          label="Accept Courses"
        ></p-checkbox>
      </div>

      <div class="field checkbox-field" *ngIf="(isGlobalInstance && !isScopeManagerOnly) || !isEditMode">
        <p-checkbox
          [binary]="true"
          formControlName="acceptChangeControls"
          label="Accept Change Controls"
        ></p-checkbox>
      </div>

      <div class="field checkbox-field" *ngIf="isGlobalInstance">
        <p-checkbox
          [binary]="true"
          formControlName="forbidChangesAfterFormattingPhase"
          label="Forbid changes after Formatting Phase"
        ></p-checkbox>
        <i
          class="fa fa-info-circle ml-2 info-icon-color"
          aria-hidden="true"
          pTooltip="{{ infoForForbidChanges }}"
        ></i>
      </div>

      <div class="field checkbox-field" *ngIf="isGlobalInstance">
        <p-checkbox
          [binary]="true"
          formControlName="isDocumentPrintingBlocked"
          label="Document Printing Blocked"
        ></p-checkbox>
      </div>

      <!-- Save Button -->
      <div class="button-container">
        <p-button 
          appPreventDoubleClick 
          type="button" 
          label="Save"
          id="scopeFormSaveButton"
          class="align-right"
          styleClass="bpt-button-compact"
          [disabled]="!eqmsScopeForm.valid || isSubmitting"
          (debounceClick)="submitScopeForm()"
         
        ></p-button>
      </div>
    </div>
  </form>
    </div>
  </div>
</section>
